import React, { useState, useEffect } from "react";
import { useParams, useHistory} from "react-router";
import {connect} from 'react-redux';
import {Actions as ACTIONS} from 'store/customer/action';
import PageHeading from 'components/PageHeading';
import CustomerBookings from 'components/customer/CustomerBookings';
import CustomerForm from 'components/customer/CustomerForm';
import Tab from '../Tab';
import Dependents from './CustomerDependents';
import CustomerCoupons from './CustomerCoupons';

const Customer = ({customer, getCustomer, clearCustomer}) => {
  	let history = useHistory();
	let { id } = useParams();

	// initialId is used for when we are clearing as it causes an issue.
  	const [initialId, setInitialId] = useState(customer && customer.id)

	useEffect(() => {
		if (!(id !== 'new' && customer && customer.id && customer.id == id)){
			getCustomer(id)
		} else if (id == 'new'){
			clearCustomer()
		}
	},[customer && customer.id]);

	useEffect(() => {
		if (id == 'new' && customer && customer.id && customer.id !== initialId && customer._version == 1){
  			history.push(`/customer/${customer.id}`)
		}
	},[customer && customer._version == 1 && customer.id]);

	if ( (!customer && id !== 'new' ) || (customer && id !== 'new' && id !== customer.id ) || (id === 'new' && customer)){

		return (
			<div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
				Loading...
			</div>
		)
	}

	return (
    <React.Fragment>
      <PageHeading
        item={customer}
        isNew={id === "new"}
        label={
          customer &&
          customer.givenName &&
          `${customer.givenName} ${customer.familyName}`
        }
      />
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Customer Details
              </h3>
              <p className="mt-1 text-sm leading-5 text-gray-500">
                This information will be displayed publicly.
              </p>
            </div>
          </div>
          <CustomerForm />
        </div>
      </div>
        {customer && (
          <Tab>
              <CustomerBookings label="Bookings" />
              <CustomerCoupons customer={customer} label="Coupons" />
              <Dependents label="Members" />
          </Tab>
        )}
    </React.Fragment>
  );
}


const mapStateToProps = (state) => {
	return {
	    customer: state.customer.item,
      services: state.service.list,
      teamMembers: state.teamMember.list,
      locations: state.location.list,
  }
}

const mapDispatchToProps = dispatch => ({
  getCustomer: (id) => dispatch(ACTIONS.getItem(id)),
  clearCustomer: () => dispatch(ACTIONS.clearItem()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Customer) 